import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import bg from '../assets/images/hero/auth.jpg'
import logo from '../assets/images/branding/logo-hap.svg'
import useCsrfToken from '../hooks/useCsrfToken';
import { Turnstile } from '@marsidev/react-turnstile'
import { setLoginUser, setLoginMember } from '../slices/authSlice';

export default function Login() {
    const { csrfToken } = useCsrfToken();
    const dispatch = useDispatch();
    const [captchaPassed, setCaptchaPassed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorDeliveringMessage, SetErrorDeliveringMessage] = useState('');
    const [errorDelivering, SetErrorDelivering] = useState(false);
    const [successDeliveringMessage, SetSuccessDeliveringMessage] = useState('');
    const [successDelivering, SetSuccessDelivering] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;
    const user = useSelector((state) => state.authentication?.user);
    // const member = useSelector((state) => state.authentication?.member);

    const TURNSTILE_KEY = '0x4AAAAAABBf7H_LASwjWDgk';

    useEffect(() => {
        if (!user) return;
        if (user && user.length > 0) {
            window.location.href = '/dashboard';
        }
    }, [user]);

    const handleCallBackTurnstile = (data) => {
        setCaptchaPassed(true);
    }

    const handleExpirationTurnstile = () => {
        setCaptchaPassed(false);
    }

    const InitLogin = (user, member) => {
        dispatch(setLoginUser(user));
        dispatch(setLoginMember(member));
    }


    const handleSubmit = async (e) => {
        setIsLoading(true);
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);

        const data = {
            dtemail: formData.get('dtemail'),
            dtpassword: formData.get('dtpassword'),
            captcharesponse: formData.get('cf-turnstile-response'),
            _token: csrfToken
        };

        try {
            const response = await fetch(`${API_URL}/api/arandaplus/login`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();
            if (result.status === 'success' && result.token !== '') {
                SetErrorDeliveringMessage('');
                SetErrorDelivering(false);
                SetSuccessDeliveringMessage(result.message);
                SetSuccessDelivering(true);
                form.reset();
                setIsLoading(false);
                setCaptchaPassed(false);
                localStorage.setItem('token', result.token);
                InitLogin(JSON.stringify(result.user), JSON.stringify(result.member));
            } else {
                SetErrorDeliveringMessage(result.message);
                SetErrorDelivering(true);
                SetSuccessDelivering(false);
                setIsLoading(false);
            }
        } catch (error) {
            SetErrorDeliveringMessage(error);
            SetErrorDelivering(true);
            SetSuccessDelivering(false);
            setIsLoading(false);
        }
    };
    return (
        <>
            <section className="bg-home d-flex align-items-center" style={{ backgroundImage: `url(${bg})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-linear-gradient-2"></div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 col-md-6 col-12">
                            <div className="p-4 bg-white rounded shadow-md mx-auto w-100" style={{ maxWidth: '400px' }}>
                                <form onSubmit={handleSubmit}>
                                    <Link to="/"><img src={logo} className="mb-4 d-block mx-auto w-50 p-2" alt="" /></Link>
                                    <h6 className="mb-3 text-uppercase fw-semibold">Ingrese a su cuenta de nuestro programa de beneficios</h6>
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold">Su Email</label>
                                        <input id="dtemail" name="dtemail" type="email" className="form-control border-primary" placeholder="Correo electrónico" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold" htmlFor="loginpass">Contraseña</label>
                                        <input type="password" name='dtpassword' className="form-control border-primary" id="dtpassword" placeholder="Contraseña" />
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span className="forgot-pass text-muted small mb-0"><Link to="/reset-password" className="text-muted">¿Olvidó su contraseña?</Link></span>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-12">
                                            <Turnstile siteKey={TURNSTILE_KEY} onSuccess={handleCallBackTurnstile} onExpire={handleExpirationTurnstile} />
                                        </div>
                                    </div>
                                    {captchaPassed && !isLoading && (
                                        <button className="btn btn-primary w-100 mt-2" type="submit">Entrar</button>
                                    )}
                                    {isLoading && (
                                        <div className="spinner-border text-success mx-auto my-2 text-center" role="status">
                                            <span className="visually-hidden text-center">Enviando, espere...</span>
                                        </div>
                                    )}
                                    {errorDelivering && (
                                        <>
                                            <br />
                                            <div className="alert alert-warning text-dark alert-dismissible fade show mt-4" role="alert">
                                                <strong>No se pudo realizar el registro, revise lo siguiente: </strong> {errorDeliveringMessage}
                                            </div>
                                        </>
                                    )}
                                    {successDelivering && (
                                        <>
                                            <br />
                                            <div className="alert alert-success alert-dismissible fade show mt-4" role="alert">
                                                <strong>{successDeliveringMessage}</strong>
                                            </div>
                                        </>
                                    )}

                                    <div className="col-12 text-center mt-3">
                                        <span><span className="text-muted me-2 small">¿Aun no tiene una cuenta?</span> <Link to="/programa-beneficios" className="text-dark fw-semibold small">Registrarme</Link></span>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
